"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.array.is-array.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.function.bind.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/esnext.weak-map.delete-all.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultIconSize = exports["default"] = exports.IconWrapper = void 0;
require("core-js/modules/es.function.name.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _nodeToText = require("@lmig/lmds-helpers/dist/nodeToText");
var _IconButtonContext = require("./IconButtonContext");
var _responsivePropsBuilder = _interopRequireDefault(require("./util/responsivePropsBuilder"));
var _useThreshold = _interopRequireDefault(require("./util/useThreshold"));
require("./icons.css");
var _excluded = ["element"],
  _excluded2 = ["id", "label", "title", "color", "className", "children", "size"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * @deprecated This interface desribes is now available under the more accurate name `IconProps`.
 * For the props of an icon wrapper, use `IconWrapperActualProps`.
 */

/* eslint-disable react/require-default-props */

/* eslint-enable react/require-default-props */

var instance = -1;

// NOTE: This size is independent from the defaultIconSize in IconButton.
var defaultIconSize = '32';
exports.defaultIconSize = defaultIconSize;
var responsivePropsConfig = {
  propKeys: ['size', 'label']
};
var El = function El(_ref) {
  var label = _ref.label,
    id = _ref.id,
    className = _ref.className,
    children = _ref.children;
  if (label) {
    return /*#__PURE__*/React.createElement("span", {
      id: id,
      className: (0, _classnames["default"])('lm-IconWrapper', className)
    }, children);
  }
  /* eslint-disable react/jsx-no-useless-fragment */
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  /* eslint-enable react/jsx-no-useless-fragment */
};
El.propTypes = {
  label: _propTypes["default"].node,
  id: _propTypes["default"].string,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};
var SpecificIcon = function SpecificIcon(_ref2) {
  var element = _ref2.element,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.cloneElement(element, _objectSpread({}, props));
};
SpecificIcon.propTypes = {
  /** Add an optional ID. If a label is provided, this ID will appear on the wrapper element: `<span class="lm-IconWrapper">`. */id: _propTypes["default"].string,
  /** Display a visual label below the icon. This label is also read out by screen readers. Use a node for instances when label requires <wbr> or other nested
     * markup. For labels on certain breakpoints only, you can specify an object of labels to render. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].shape({
    base: _propTypes["default"].node,
    sm: _propTypes["default"].node,
    md: _propTypes["default"].node,
    lg: _propTypes["default"].node,
    xl: _propTypes["default"].node
  })]),
  /** Specify the icon's title that will be read out by screen readers, similar to the "alt" attribute on image tags, and displayed in a browser default tooltip.
     * If no title is provided, this will use the label.
     * If no label is provided, this will default to the icon name.
     */
  title: _propTypes["default"].string,
  /**
     * Apply a color to the icon. By default, icons display in Liberty Blue.
     * `Success` and `error` are deprecated; use `positive` and `negative` instead.
     * @default 'blue'
     */
  color: _propTypes["default"].oneOf(['blue', 'caution', 'disabled', 'error', 'gray', 'informative', 'inverse', 'negative', 'positive', 'success', 'teal']),
  /** Hide icon from screen readers. */ariaHidden: _propTypes["default"].bool,
  /** Add custom classes. If a label is provided, this class will appear on the wrapper element: `<span class="lm-IconWrapper">`. */className: _propTypes["default"].string,
  element: _propTypes["default"].any.isRequired
};
var IconWrapper = function IconWrapper(props) {
  var _props$size = props.size,
    originalSize = _props$size === void 0 ? defaultIconSize : _props$size;
  var size = typeof originalSize === 'string' ? originalSize : _objectSpread({
    base: defaultIconSize
  }, originalSize);
  var responsiveProps = (0, _responsivePropsBuilder["default"])((0, _useThreshold["default"])(), _objectSpread(_objectSpread({}, props), {}, {
    size: size
  }), responsivePropsConfig);

  // NOTE: With github version of props builder, React element labels are overwritten. FIXME :)
  // TODO: See if there's a better way to do this.
  var _ref3 = _objectSpread(_objectSpread({}, props), responsiveProps),
    id = _ref3.id,
    label = _ref3.label,
    title = _ref3.title,
    _ref3$color = _ref3.color,
    color = _ref3$color === void 0 ? 'blue' : _ref3$color,
    className = _ref3.className,
    children = _ref3.children,
    _ref3$size = _ref3.size,
    iconSize = _ref3$size === void 0 ? '32' : _ref3$size,
    iconProps = _objectWithoutProperties(_ref3, _excluded2);

  // deprecation warnings
  React.useEffect(function () {
    if (color === 'success') {
      // eslint-disable-next-line no-console
      console.warn( // eslint-disable-next-line
      // @ts-ignore
      "Warning: color=\"success\" is deprecated in ".concat(children.type.name, " and will be removed in the next major release.\n        Use color=\"positive\" instead."));
    }
    if (color === 'error') {
      // eslint-disable-next-line no-console
      console.warn( // eslint-disable-next-line
      // @ts-ignore
      "Warning: color=\"error\" is deprecated in ".concat(children.type.name, " and will be removed in the next major release.\n        Use color=\"negative\" instead."));
    }
  }, [color]);
  var _React$useState = React.useState(function () {
      if (label) {
        instance++;
        return id ? "".concat(id, "-label") : "icon-".concat(instance, "-label");
      }
      return undefined;
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    uniqueIdforLabel = _React$useState2[0];
  var setIconButtonSize = (0, _IconButtonContext.useIconButtonContext)();
  React.useEffect(function () {
    if (typeof setIconButtonSize === 'function') {
      setIconButtonSize(iconSize || defaultIconSize);
    }
  }, [iconSize, setIconButtonSize]);

  /** Creates the title to use on the icon.
   * If there is a title, use the title.
   * If there is a label, convert that node to a string via the nodeToText helper.
   * Otherwise, return undefined. Undefined will default to the icon's title.
   * @see {@link nodeToText}
   */
  var handleIconTitle = function handleIconTitle() {
    if (title !== undefined) return title;
    if (label) return (0, _nodeToText.nodeToText)(label);
    return undefined;
  };
  return /*#__PURE__*/React.createElement(El, {
    label: label,
    id: id,
    className: className
  }, /*#__PURE__*/React.createElement(SpecificIcon, _extends({
    element: children,
    color: color,
    id: label ? undefined : id,
    className: label ? undefined : className,
    title: handleIconTitle(),
    "aria-labelledby": label ? uniqueIdforLabel : undefined,
    size: iconSize
  }, iconProps)), label && /*#__PURE__*/React.createElement("span", {
    id: uniqueIdforLabel,
    className: "lm-Icon-label"
  }, label));
};

// Outside of icons, most LMDS components don't provide default exports.
// We're keeping this default export in place for compatibility.
exports.IconWrapper = IconWrapper;
IconWrapper.propTypes = {
  /** Add an optional ID. If a label is provided, this ID will appear on the wrapper element: `<span class="lm-IconWrapper">`. */id: _propTypes["default"].string,
  /** Display a visual label below the icon. This label is also read out by screen readers. Use a node for instances when label requires <wbr> or other nested
     * markup. For labels on certain breakpoints only, you can specify an object of labels to render. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].shape({
    base: _propTypes["default"].node,
    sm: _propTypes["default"].node,
    md: _propTypes["default"].node,
    lg: _propTypes["default"].node,
    xl: _propTypes["default"].node
  })]),
  /** Specify the icon's title that will be read out by screen readers, similar to the "alt" attribute on image tags, and displayed in a browser default tooltip.
     * If no title is provided, this will use the label.
     * If no label is provided, this will default to the icon name.
     */
  title: _propTypes["default"].string,
  /**
     * Apply a color to the icon. By default, icons display in Liberty Blue.
     * `Success` and `error` are deprecated; use `positive` and `negative` instead.
     * @default 'blue'
     */
  color: _propTypes["default"].oneOf(['blue', 'caution', 'disabled', 'error', 'gray', 'informative', 'inverse', 'negative', 'positive', 'success', 'teal']),
  /** Hide icon from screen readers. */ariaHidden: _propTypes["default"].bool,
  /** Add custom classes. If a label is provided, this class will appear on the wrapper element: `<span class="lm-IconWrapper">`. */className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
var _default = IconWrapper;
exports["default"] = _default;